import { render, staticRenderFns } from "./DetailsLayout.vue?vue&type=template&id=29ad0f44"
import script from "./DetailsLayout.vue?vue&type=script&lang=ts"
export * from "./DetailsLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports